import React from 'react';
import styles from './ProductNameBadge.module.scss';

export function ProBadge() {
  return (
    <div className={styles.proBadge}>
      <span>Pro</span>
    </div>
  );
}

export function TeamsBadge() {
  return (
    <div className={styles.teamsBadge}>
      <span>Teams</span>
    </div>
  );
}
